// extracted by mini-css-extract-plugin
export var reactivateTodayDisclaimer = "ReactivateTodayDisclaimer_reactivateTodayDisclaimer__qtzHr";